import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";

export default function Designers() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/designers").then((r) => setItems(r.data)); }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-10">
      <p className="overline">The makers</p>
      <h1 className="serif text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-1 mb-10">Designers</h1>
      <div className="grid gap-px bg-border border border-border sm:grid-cols-2">
        {items.map((d) => (
          <Link key={d.slug} to={`/designers/${d.slug}`} className="bg-card p-8 hover:bg-secondary/50 transition-colors group" data-testid={`designer-tile-${d.slug}`}>
            <div className="flex items-baseline justify-between gap-4">
              <h2 className="serif text-2xl group-hover:text-accent transition-colors">{d.name}</h2>
              <span className="text-sm text-muted-foreground shrink-0">{d.chair_count} chairs</span>
            </div>
            <p className="overline mt-1">{d.nationality} · {d.years}</p>
            <p className="text-sm text-muted-foreground mt-3 line-clamp-2">{d.bio}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
